import { useEffect, useState } from 'react';

/**
 * The current time, re-read every `intervalMs`.
 *
 * For a page that is left open across a deadline — a signup slot locking while the parent is
 * still looking at it — so the buttons change without a reload. A minute is plenty: the database
 * enforces the same deadline, and the page only has to stop offering what it would refuse.
 */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
